module.exports = __webpack_public_path__ + "img/pirze_img_point.ad2279ae.png";